import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { HttpService } from '../../../services/http.service';
import { Router} from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import { APPCONFIG } from '../../../config';
import { errorDialogDuplicate} from './error/error-example';
import { MatDialog,MatDialogRef, MatDialogConfig} from '@angular/material/dialog';
import { UserAgentApplication } from 'msal';

declare var require: any;
interface LoginResponse {
    accessToken: string;
    accessExpiration: number;
  }

declare const gapi: any;

@Component({
    selector   : 'login-2',
    templateUrl: './login-2.component.html?v=${APPCONFIG.cacheVersion}',
    styleUrls  : ['./login-2.component.scss?v=${APPCONFIG.cacheVersion}'],
    
    providers: [ HttpService]
})



export class Login2Component implements OnInit, OnDestroy
{
    readonly white_app_logo = APPCONFIG.white_app_logo;
    readonly blue_app_logo = APPCONFIG.blue_app_logo;
    name:string = "";
    id:number;
    idToken:string= ""; 
    resultUser :any;
    dialogRef;
    confirmDialogRefSession: MatDialogRef<any>;
    errorDialogRef: MatDialogRef<errorDialogDuplicate>;
    title:any;
    loginForm: FormGroup;
    loginFormErrors: any;

    userAgentApplication;
    userData;
    microsoftLogin=false;
    isProdEnvironment=APPCONFIG.isProdEnvironment;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private http1: HttpService, public dialog: MatDialog, private http:HttpClient, private router: Router,
        private _fuseConfigService: FuseConfigService, private _formBuilder: FormBuilder, public _matDialogRef: MatDialogRef<Login2Component>
    ){
        const msalConfig = {
            auth: {
                clientId: APPCONFIG.microsoft_client_id,
                knownAuthorities: [],
                redirectUri: APPCONFIG.frontEndUrl,
                postLogoutRedirectUri: APPCONFIG.frontEndUrl,
                navigateToLoginRequestUrl: true,
            }
        };
        //'2b003a99-9eb9-4240-a695-18ca8acffbae'
        this.userAgentApplication = new UserAgentApplication(msalConfig);
        this.userAgentApplication.handleRedirectCallback((error, response) => {
            console.log('error==>');
            console.log(error);
            console.log('response==>');
            console.log(response);
        });

        if (this.http1.loginCheckSession()) {
            let user = JSON.parse(localStorage.getItem('user'));
            if(user.role.roleType=='QA') {
                window.location.href="./podQualityCheck";
            }else if(user.role.roleType=='WarehouseMan') {
                window.location.href="./jobsummary";
            }else {
                window.location.href="./depot/list";
            }
        }
        
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar : {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer : {
                    hidden: true
                }
            }
        };

        // Set the defaults
        this.loginFormErrors = {
            username: {},
            password: {}
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }
    
    public tokenReceivedCallback(errorDesc, token, error, tokenType) {
        if (token) {
            this.userData = token;

            console.log("Token: " + token)
        } else {
            console.log(error + ":" + errorDesc);
        }
    }

    postData(token,username,password,isWpassLogin){
        const httpOptions = {
        	headers : new HttpHeaders({
        	'Content-Type': 'application/json',
        	'idToken': token
            }) };
        var body = {};
        if(isWpassLogin) {
            body = {'wpassId':username,'password':password};
        } else {
            body = {'email':username,'microsoftLogin':this.microsoftLogin};
        }

        this.http.post(APPCONFIG.appUrl+'/manage/weblogin',body, httpOptions)
        /* .catch((error:any) => Observable.throw(this.handleError(error) || 'Server error')) */
        .subscribe(result => 
           { 
            localStorage.setItem("timestamp", Math.round(new Date().getTime()/1000.0).toString());
            if (result){ 
                this.resultUser = result;
                localStorage.setItem('user',JSON.stringify(this.resultUser.data)); 
                localStorage.setItem('uid',JSON.stringify(this.resultUser.data.uid));
                localStorage.setItem('roleId',JSON.stringify(this.resultUser.data.role.roleId));
                if(isWpassLogin) {
                    localStorage.setItem('Token',JSON.stringify(this.resultUser.data.token));
                }
                
                if(this.resultUser.data.role.roleType=='QA') {
                    window.location.href="./podQualityCheck";
                }
                else if(this.resultUser.data.role.roleType=='WarehouseMan') {
                    window.location.href="./jobsummary";
                }
                else if(localStorage.getItem('userRedirectPath')){
                    let userRedirectPath = localStorage.getItem('userRedirectPath')
                    localStorage.removeItem('userRedirectPath');
                    window.location.href= "."+userRedirectPath;
                }
                else{
                    localStorage.removeItem('userRedirectPath');
                    window.location.href="./depot/list";
                }
                //return true;
            } 
              
        },
        err => {
            if (err.error.httpStatusCode == 401 || err.error.httpStatusCode == 400 || err.status == 400) {
                this.errorDialogRef = this.dialog.open(errorDialogDuplicate);
                if(err.error.statusCode == 10 && err.error.errorMsg) {
                    this.errorDialogRef.componentInstance.title = err.error.errorMsg;
                }
            } 
            else if (err.statusText == "Unknown Error"){
                
            }
          }
    );  
    }

    loginUrl = APPCONFIG.appUrl+"/_ah/api/userDetailsOperations/v1/login"
    public auth2: any;
    public googleInit() {
      gapi.load('auth2', () => {
        this.auth2 = gapi.auth2.init({
          client_id: APPCONFIG.google_client_id, 
            cookiepolicy: 'single_host_origin',
            prompt:'consent',
          scope:  'profile email'
        });
        
        this.attachSignin(document.getElementById('googleBtn'));
      });
    }

    public attachSignin(element) {
      this.auth2.attachClickHandler(element, {},
        (googleUser) => {
        
          let profile = googleUser.getBasicProfile();
          let email = profile.getEmail();
          localStorage.setItem('Token',JSON.stringify(googleUser.getAuthResponse().id_token));
          this.microsoftLogin=false;  
          this.postData(googleUser.getAuthResponse().id_token,email,'',false);
          
            
        }, (error) => {
          /* console.log(JSON.stringify(error, undefined, 2)); */
        });
    }

    public microsoftSignIn() {
        var graphScopes = ['profile'];
        let that = this;
        that.userAgentApplication.loginPopup(graphScopes).then(function(res) {
            console.log(res);
            localStorage.setItem('Token',JSON.stringify(res.idToken.rawIdToken)); 
            that.microsoftLogin=true; 
            that.postData(res.idToken.rawIdToken,res.idToken.preferredName,'',false);

        }, function(error) {
            console.log(error);
        });
    }

    loginByWpass():void {
        var username = this.loginForm.value.username;
        var password = this.loginForm.value.password;
        this.microsoftLogin=false;
        this.postData('',username,password,true);
    }
  
  ngAfterViewInit(){
        this.googleInit();
  }



   

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    
    /**
     * On init
     */
    ngOnInit(): void
    {
        
        // localStorage.removeItem("timestamp");
        
        this.loginForm = this._formBuilder.group({
            //email   : ['', [Validators.required, Validators.email]],
            username   : ['', [Validators.required]],
            password: ['', Validators.required]
        });
        console.log('ENV:'+APPCONFIG.env);

        /* this.loginForm.valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.onLoginFormValuesChanged();
            }); */

        
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On form values changed
     */
    onLoginFormValuesChanged(): void
    {
        for ( const field in this.loginFormErrors )
        {
            if ( !this.loginFormErrors.hasOwnProperty(field) )
            {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);

            if ( control && control.dirty && !control.valid )
            {
                this.loginFormErrors[field] = control.errors;
            }
        }
    }
}
